<!--
 * @Author: your name
 * @Date: 2021-01-04 13:42:20
 * @LastEditTime: 2021-03-19 16:08:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\views\Home\common\Payment.vue
-->
<template>
  <div id='payment'>
    <!-- 协会管理员 -->
    <el-row class="goBackHome" v-if="(roleType==2&&$parent.tabIndex==6)||(roleType==3&&$parent.tabIndex==6)">
      <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
        <span class="clickBack" @click="$parent.tabIndex=0"><img src="@/assets/img/back.png" alt="">返回</span>
      </el-col>
      <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
        <span style="color: #333333;" v-if="roleType==2">我的工作台 > </span>
        <span style="color: #333333;" v-if="roleType==3">我的申请 > </span>
        {{quesNaireData.applyName}}
      </el-col>
    </el-row>
    <template v-if="quesNaireData">
      <el-row class="quesStartInfo" v-if="(quesNaireData.recipientPerson==null||quesNaireData.recipientPerson==''||quesNaireData.recipientPerson==userId)&&roleType==2&&quesNaireData.applyStatus!=5&&quesNaireData.applyStatus!=4">
        <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14" class="applyColor">
          <el-row style="margin-bottom:10px;">
            <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16">
              公司名 :
              <span class="leftMargin">{{quesNaireData.companyName}}</span>
            </el-col>
            <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
              发起时间 :
              <span class="leftPadding">{{quesNaireData.createTime.substr(0,10)}}</span>
            </el-col>
          </el-row>
          <el-row>
            申请内容 : <span class="leftPadding">{{quesNaireData.applyName}}</span>
          </el-row>
        </el-col>
        <template v-if="quesNaireData.taskStatus==2">
          <el-col class=" taskBack" :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
            <div @click="taskBack">
              任务退回
              <img src="@/assets/img/任务退回.png" alt="">
            </div>
          </el-col>
          <el-col style="text-align:right;margin-right:20px;" :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
            <el-button class="button add esc" style="margin-bottom:0px;" @click="$refs.ExamineDialog.isSuccess(5)">同意</el-button>
            <el-button class="button esc" style="margin-bottom:0px;" @click="$refs.ExamineDialog.applyVisible=true">拒绝</el-button>
          </el-col>
        </template>
        <template v-if="quesNaireData.taskStatus==1">
          <el-col class="receiveTask" :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
            <el-button class="button receive" @click="acceptTask">接受任务</el-button>
          </el-col>
        </template>
      </el-row>
      <!-- <el-row class="applyReason" v-if="roleType == 2 && $route.name == 'AdminApplication'"> -->
      <el-row class="applyReason" v-if="roleType == 2 && $route.name == 'AdminApplication'&&remarkReason?remarkReason.length>0:''">
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">原因说明：</el-col>
        <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">{{remarkReason}}</el-col>
      </el-row>
    </template>
    <el-row class="addContact" v-if="(roleType==3&&$parent.tabIndex!=6)||(roleType==2&&(userPermissionType=='6'||userPermissionType=='6,7')&&$parent.tabIndex!=6)" @click.native="addPayNum">
      <i class="el-icon-plus"> 添加缴费记录</i>
    </el-row>
    <el-table :data="payTableData" stripe style="width: 100%">
      <el-table-column prop="year" label="所缴会费年份">
        <template slot-scope="scope">
          <template v-if="roleType==2&&$route.name=='Management'">
            <span>{{scope.row.year}}</span>
            <span v-if="scope.row.approveStatus==1||scope.row.approveStatus==2||scope.row.approveStatus==3" class="nowing">进行中</span>
          </template>
          <template v-if="roleType==3||(roleType==2&&$route.name=='AdminApplication')">{{scope.row.year}}</template>
        </template>
      </el-table-column>
      <el-table-column prop="memberGrade" label="该年会员等级">
        <template slot-scope="scope">
          <span v-if="scope.row.memberGrade==1">会长</span>
          <span v-else-if="scope.row.memberGrade==2">副会长</span>
          <span v-else-if="scope.row.memberGrade==3">理事会员</span>
          <span v-else-if="scope.row.memberGrade==4">普通会员</span>
        </template>
      </el-table-column>
      <el-table-column prop="paymentMoney" label="缴费金额（单位: 元）">
      </el-table-column>
      <el-table-column prop="createTime" label="日期">
        <template slot-scope="scope">
          <span>{{scope.row.paymentTime==null?'':$dayjs(scope.row.paymentTime).format('YYYY-MM-DD')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="proofPayment" label="付款凭证">
        <template slot-scope="scope">
          <el-link class="downLoad" @click="downLoadPay(scope.row.proofPaymentName,scope.row.proofPayment)" :download="scope.row.proofPaymentName">{{scope.row.proofPaymentName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="approveStatus" v-if="(roleType==3&&$route.name=='Management')||(roleType==2&&(userPermissionType=='6'||userPermissionType=='6,7')&&$parent.tabIndex!=6)">
        <template slot-scope="scope">
          <span v-if="scope.row.approveStatus==1" class="applyAdd">申请添加中</span>
          <span v-else-if="scope.row.approveStatus==2" class="applyAdd">申请修改中</span>
          <span v-else-if="scope.row.approveStatus==3" class="applyAdd">申请删除中</span>
          <template v-else-if="scope.row.approveStatus==5">
            <span class="downLoad" @click="editPay(scope.row)">修 改</span>
            <span class="downLoad delete" @click="deletePay(scope.row)">删 除</span>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="(roleType == 3||roleType == 2)&&$route.name=='Management'" @current-change="paymentRecordChange" :current-page.sync="payParams.pageNumber" :page-size="payParams.pageSize" layout="total, prev, pager, next" :total="paymentTotal">
    </el-pagination>
    <!-- 添加缴费记录对话框 -->
    <el-dialog :title="payTitleName" :visible.sync="addPayVisible" width="30%" custom-class="addPayVisible" @close="closePayDialog" @open="openPayDialog">
      <el-alert v-if="roleType == 3 && payFlag==2"
        title="若修改审核未通过，则该年份原来的缴费记录也会被删除"
        type="warning" :closable="false" show-icon
      >
      </el-alert>
      <el-form :model="addPayForm" :rules="addPayFormRules" ref="addPayForm" label-width="130px" class="demo-ruleForm" v-if="addSuccess==0">
        <el-form-item label="所缴会费年份：" prop="year">
          <el-select v-model="addPayForm.year" placeholder="请选择催缴年份" @change="callYear" clearable v-if="(payFlag==1||payFlag == 2||payFlag == 3)&&payTitleName=='新增缴费记录'">
            <el-option v-for="item in yearList" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
          <span v-if="payFlag==2&&payTitleName=='修改缴费记录'">{{addPayForm.year}}</span>
        </el-form-item>
        <template v-if="payFlag==3">
          <el-form-item label="缴费金额：">
            <span>{{callPayData.shouldPayFee}}</span>
            <span class="editPayList" @click="editPayList">修 改</span>
          </el-form-item>
          <el-form-item label="该年会员等级：">
            <span v-if="callPayData.memberGrade==1">会长</span>
            <span v-else-if="callPayData.memberGrade==2">副会长</span>
            <span v-else-if="callPayData.memberGrade==3">理事会员</span>
            <span v-else-if="callPayData.memberGrade==4">普通会员</span>
          </el-form-item>
        </template>
        <template v-if="payFlag==2">
          <el-form-item label="缴费金额：" prop="paymentMoney" class="payNums">
            <el-input v-model="addPayForm.paymentMoney" clearable></el-input><span class="unit">(单位:元)</span>
          </el-form-item>
          <el-form-item label="该年会员等级" prop="memberGrade">
            <el-select v-model="addPayForm.memberGrade" placeholder="请选择会员等级">
              <el-option v-for="item in levelOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="缴费时间：" prop="paymentTimeStr">
          <!-- <el-input v-model="addPayForm.paymentTimeStr"></el-input> -->
          <el-date-picker v-model="addPayForm.paymentTimeStr" type="date" placeholder="请选择日期" :picker-options="pickerDisabled">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="上传付款凭证：" prop="proofPayment">
          <el-upload class="upload-demo" :headers="headerObj" :action="uploadUrl" :on-success="handleSuccess" :on-progress="uploadProcess" :before-upload="beforeAvatarUpload" :file-list="payFileList" :on-remove="removePay">
            <span class="uploaadImg"><img src="@/assets/img/上传.png" alt="">点击上传</span>
            <!-- <span slot="tip" :show-file-list="!progressFlag"  class="el-upload__tip" :style="{color:activeColor}">{{message}}</span> -->

          </el-upload>

          <!-- <span v-if="progressFlag"><i class="el-icon-document"></i> &nbsp;{{addPayForm.proofPaymentName}}</span>
          <el-progress v-if="progressFlag" :percentage="loadProgress" :stroke-width="2"></el-progress> -->
        </el-form-item>
        <el-form-item label="修改原因：" prop="remark" v-if="payFlag==2">
          <el-input type="textarea" v-model="addPayForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <div v-if="addSuccess==1" style="text-align:center;">
        <img src="@/assets/img/修改成功.png" alt="">
        <p style="font-size:16px;font-weight:700;margin:15px 0;">提交成功</p>
        <span v-if="(payFlag==3||payFlag==2)&&payTitleName=='新增缴费记录'">添加缴费记录已提交,正等待管理员审核!</span>
        <span v-if="payFlag==2&&payTitleName=='修改缴费记录'">修改缴费记录已提交,正等待管理员审核!</span>
        <span v-if="payFlag==4">删除缴费记录已提交,正等待管理员审核!</span>
      </div>
      <el-row v-if="addSuccess==2">
        <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" style="padding-left:20px;font-size:15px;">删除原因</el-col>
        <el-col :xs="19" :sm="19" :md="19" :lg="19" :xl="19">
          <el-input type="textarea" class="deleteReason" placeholder="请填写删除原因" v-model="addPayForm.remark"></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <span class="button add" type="primary" @click="addPaymentRecord" v-if="addSuccess==0">确 定</span>
        <span class="button add" type="primary" @click="addSuccessfull" v-if="addSuccess==1">确 定</span>
        <span class="button add" type="primary" @click="deleteInfo" v-if="addSuccess==2">确 定</span>
        <span class="button" v-if="addSuccess==0||addSuccess==2" @click="addPayVisible = false">取 消</span>
      </span>
    </el-dialog>
    <ExamineDialog ref="ExamineDialog" />
    <!-- 任务退回对话框 -->
    <BackDialog ref="BackDialog" />
  </div>
</template>
<script>
import ExamineDialog from '@/views/Home/common/ExamineDialog'
import BackDialog from '@/views/Home/common/BackDialog.vue'
import { downLoadFiles } from '@/assets/js/common'
import { findPaymentRecord, deleteRecord, paymentRecord, taskManagement, findMembershipFeeList, findPaymentInformation, } from '@/api/index'
export default {
  props: ['quesNaireData'],
  data() {
    return {
      userId: sessionStorage.getItem('userId'),
      roleType: window.sessionStorage.getItem('roleType'),
      userPermissionType: window.sessionStorage.getItem('userPermissionType'),
      headerObj: { token: window.sessionStorage.getItem('token') },
      uploadUrl: '', // 单文件
      payFlag: 1,  // 3显示缴费金额和该年会员等级点击修改按钮可修改 2直接可编辑会员等级和金额 1添加缴费记录
      addPayVisible: false,
      payFileList: [],
      addPayForm: {
        id: '',
        year: "",
        paymentMoney: '',
        proofPayment: '',
        proofPaymentName: "",
        paymentTimeStr: '',
        userId: "",
        memberGrade: '',
        remark: ""
      },
      addPayFormRules: {
        year: [
          { required: true, message: '请选择缴费年份', trigger: 'blur' },
        ],
        paymentMoney: [
          { required: true, message: '请输入缴费金额', trigger: 'blur' },
        ],
        memberGrade: [
          { required: true, message: '请输入会员等级', trigger: 'blur' }
        ],
        proofPayment: [
          { required: true, message: '请上传付款凭证', trigger: 'blur' },
        ],
        paymentTimeStr: [
          { required: true, message: '请选择缴费时间', trigger: 'blur' },
        ],
        remark: [
          { required: true, message: '请填写修改原因', trigger: 'blur' },
        ],
      },
      message: '（不超过100M，支持扩展名：.rar .zip）',
      activeColor: '#999',
      payParams: {
        pageNumber: 1,
        pageSize: 5,
        userId: ''
      },
      paymentTotal: 0,
      payTableData: [],
      //禁用当天之后的时间
      pickerDisabled: {
        disabledDate: (time) => {
          return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
        }
      },
      payTitleName: "",
      yearList: JSON.parse(localStorage.getItem('payAllYear')),
      callPayData: {},
      yearParams: {
        year: "",
        createUserId: ""
      },
      levelOptions: [{
        value: 1,
        label: '会长'
      }, {
        value: 2,
        label: '副会长'
      }, {
        value: 3,
        label: '理事会员'
      }, {
        value: 4,
        label: '普通会员'
      }],
      addSuccess: 0,
      loadProgress: 0, // 动态显示进度条
      progressFlag: false, // 关闭进度条
      remarkReason: "",
    }
  },
  created() {
    // this.addPayForm.year = this.yearList ? this.yearLis[0] : ""
    // this.addPayForm.year = this.yearList.length > 0 ? this.yearLis[0] : ""
    this.uploadUrl = this.$http.defaults.baseURL + 'user/uploadFile'
    this.findPaymentRecord()
  },
  methods: {
    // five() {
    //   // $children[5].isSuccess(5)
    // },
    // 任务退回
    taskBack() {

      this.$refs.BackDialog.titleName = '任务退回'
      this.$refs.BackDialog.refuseVisible = true
      this.$refs.BackDialog.step = 1
      this.$refs.BackDialog.receiveParams.id = this.quesNaireData.id
    },
    // 接受任务
    async acceptTask() {
      this.$refs.BackDialog.receiveParams.id = this.quesNaireData.id
      this.$refs.BackDialog.receiveParams.taskStatus = 2
      const { data } = await taskManagement(this.$refs.BackDialog.receiveParams)
      if (data.code != 0) return
      this.quesNaireData.taskStatus = 2
      this.$parent.findAllTask()
      // this.quesNaireData = this.$parent.taskList.find(item => item.id == this.quesNaireData.id)
    },
    // 查询缴费记录
    async findPaymentRecord() {
      if ((this.roleType == 2 && this.$route.name == 'AdminApplication') || (this.roleType == 3 && this.$route.name == 'Application')) {
        this.payTableData = [JSON.parse(this.quesNaireData.param)]

        this.remarkReason = this.payTableData[0].remark
      } else {
        if (this.roleType == 3) {
          this.payParams.userId = this.userId
        } else if (this.roleType == 2) {
          this.payParams.userId = this.$route.query.id
        }
        // this.payParams.userId = this.roleType == 3 ? this.userId : this.$route.query.id
        const { data } = await findPaymentRecord(this.payParams)
        if (data.code == 0) {
          this.payTableData = JSON.parse(JSON.stringify(data.paymentRecordList))
          this.paymentTotal = data.total
        }
      }
    },
    //添加缴费记录
    addPayNum() {
      this.addSuccess = 0
      this.payFlag = 1
      this.payTitleName = '新增缴费记录'
      this.addPayVisible = true
    },
    // 催缴年份
    async callYear(val) {
      this.yearParams.year = val
      if (this.roleType == 3) {
        this.yearParams.createUserId = this.userId
      } else if (this.roleType == 2) {
        this.yearParams.createUserId = this.$route.query.id
      }
      if (val == '' || val == null) {
        this.payFlag = 1
      } else {
        this.payFlag = 3
        const { data } = await findPaymentInformation(this.yearParams)
        if (data.code != 0) return
        this.callPayData = JSON.parse(JSON.stringify(data.paymentInformationDto))
        // this.addPayForm.paymentMoney = this.callPayData.shouldPayFee
        // this.addPayForm.memberGrade = this.callPayData.memberGrade

      }
    },
    // 修改会员等级
    editPayList() {
      this.payFlag = 2
    },
    // changeLevel() { },
    // 修改缴费记录
    editPay(row) {
      this.addSuccess = 0
      this.payFlag = 2
      this.payTitleName = '修改缴费记录'
      this.addPayVisible = true
      this.addPayForm.id = row.id
      this.addPayForm.year = row.year
      this.addPayForm.memberGrade = row.memberGrade
      this.addPayForm.paymentMoney = row.paymentMoney
      this.addPayForm.remark = ''
      this.addPayForm.proofPayment = row.proofPayment
      this.addPayForm.paymentTimeStr = row.paymentTime.slice(0, 10)
      this.payFileList.push({ name: row.proofPaymentName, url: row.proofPayment })
    },
    deletePay(row) {

      this.addPayForm.remark = ''
      this.addSuccess = 2
      this.payTitleName = '申请删除'
      this.payFlag = 4
      this.addPayVisible = true
      this.addPayForm.id = row.id
    },
    async deleteInfo() {
      if (this.addPayForm.remark == '') {
        this.$message.error('请填写删除信息!')
      } else {
        const { data } = await deleteRecord(this.addPayForm)
        if (data.code != 0) return
        if (this.roleType == 2) {
          this.addPayVisible = false
          this.findPaymentRecord()
        } else if (this.roleType == 3) {
          this.addSuccess = 1
        }
      }
    },
    // 新增缴费记录
    addPaymentRecord() {
      if (this.payFlag == 3) {
        this.addPayForm.paymentMoney = this.callPayData.shouldPayFee
        this.addPayForm.memberGrade = this.callPayData.memberGrade
      }
      this.addPayForm.userId = this.roleType == 3 ? this.userId : this.$route.query.id
      this.addPayForm.paymentTimeStr = this.$dayjs(this.addPayForm.paymentTimeStr).format('YYYY-MM-DD HH:mm:ss')
      this.$refs.addPayForm.validate(async (valid) => {
        if (valid) {
          try {
            const { data } = await paymentRecord(this.addPayForm)
            if (data.code !== 0) return
            if (this.roleType == 2) {
              this.addPayVisible = false
              this.findPaymentRecord()
            } else if (this.roleType == 3) {
              this.addSuccess = 1
            }
          } catch (error) {
            this.$message.error(error.data.msg)
          }


        }
      })
    },
    addSuccessfull() {
      this.addPayVisible = false
      this.findPaymentRecord()
    },
    handleSuccess(file, fileList) {
      this.message = "上传成功"
      
      this.payFileList = []
      this.addPayForm.proofPayment = file.fileUrl;
      this.payFileList.push({ name: fileList.raw.name, url: fileList.response.fileUrl })
    },
    
    uploadProcess(event, file, fileList) {
      if (event.percent == 100) {
        event.percent = 90;
      }
    },
    // 上传文件前校验
    beforeAvatarUpload(file) {
      this.addPayForm.proofPaymentName = file.name;
      
    },
    // 缴费记录当前页发生改变
    paymentRecordChange(val) {
      this.payParams.pageNumber = val
      this.findPaymentRecord()
    },
    openPayDialog() {

      if (this.payFlag == 1) {
        // this.addPayForm = {}
        for (let k in this.addPayForm) {
          this.addPayForm[k] = ''
        }
        this.payFileList = []
      }
    },
    closePayDialog() {
      if (this.addSuccess == 0) {
        this.$refs.addPayForm.resetFields()
      } else if (this.addSuccess == 1) {
        this.addPayForm = {
          id: '',
          year: "",
          paymentMoney: '',
          proofPayment: '',
          proofPaymentName: "",
          paymentTimeStr: '',
          userId: "",
          memberGrade: '',
          remark: ""
        }
      }
      this.payFileList = []
    },
    //下载缴费记录
    downLoadPay(fileName, file) {
      downLoadFiles(fileName, file)
    },
    // 移除上传的缴费文件
    removePay(file) {
      const filePath = file.url
      // //使用findIndex来查找符合条件的索引
      const index = this.payFileList.findIndex(item => item.url === filePath)
      // //移除索引对应的图片
      this.payFileList.splice(index, 1)
    },
  },
  components: {
    ExamineDialog,
    BackDialog
  }
}
</script>
<style lang='less' scoped>
#payment {
  .uploaadImg {
    display: inline-block;
    width: 134px;
    height: 34px;
    line-height: 34px;
    border-radius: 17px;
    border: solid 1px #0566cc;
    color: #0066cc;
    font-size: 16px;
    margin-right: 15px;
    cursor: pointer;
    img {
      vertical-align: middle;
      padding-right: 5px;
    }
  }

  /deep/.addPayVisible {
    .el-date-editor.el-input {
      width: 324px;
      // background: #fff;
    }
    .el-input {
      width: 80%;
    }
    .el-input__inner {
      background: #fff;
    }
    .el-textarea {
      width: 81%;
    }
    .el-upload-list__item {
      width: 83%;
    }
    .payNums {
      .el-input {
        width: 45%;
      }
      .unit {
        display: inline-block;
        margin-left: 10px;
        color: #ccc;
      }
    }
  }
  .editPayList {
    display: inline-block;
    background: linear-gradient(-45deg, #0566cc 0%, #3793f4 100%);
    color: #fff;
    margin-left: 20px;
    width: 75px;
    height: 28px;
    line-height: 28px;
    border-radius: 14px;
    border: solid 1px #0566cc;
    text-align: center;
    cursor: pointer;
  }
  .nowing {
    position: absolute;
    display: inline-block;
    background: #ecf5ff;
    border: 1px solid #9cd9ff;
    color: #3096ff;
    width: 55px;
    height: 24px;
    right: 25px;
    border-radius: 7px;
  }
}
@media screen and (max-width: 1680px) {
  #payment {
    .payNums {
      .el-input {
        width: 53% !important;
      }
    }
  }
}
</style>
